module.exports = __webpack_public_path__ + "47d6d3a15043c2a2fb0802d8da9bf071.png";